import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HookHandlerClass;
function HookHandler() {
  if (HookHandlerClass === VOID) {
    class $ {
      constructor(hook, handler) {
        this.j5s_1 = hook;
        this.k5s_1 = handler;
      }
      u5g(client) {
        this.j5s_1.k5m(client, this.k5s_1);
      }
    }
    initMetadataForClass($, 'HookHandler');
    HookHandlerClass = $;
  }
  return HookHandlerClass;
}
//region block: exports
export {
  HookHandler as HookHandler356pvj77mag23,
};
//endregion

//# sourceMappingURL=ClientHook.mjs.map
